import type { FormKitNode, FormKitTypeDefinition } from '@formkit/core'
import { createInput } from '@formkit/vue'

export const ColorPicker: FormKitTypeDefinition = createInput({
  type: 'input',
  features: [
    (node: FormKitNode) => {
      node.on('created', () => {
        node.context!.handlers.update = (newInputValue: string) =>
          node.input(newInputValue)
      })
    },
  ],
  $el: 'div',
  children: [
    {
      $el: 'input',
      attrs: {
        type: 'color',
        class: ['p-color'],
        onInput: '$handlers.DOMInput',
        value: '$_value',
      },
    },
    {
      $el: 'input',
      attrs: {
        class: 'p-input',
        onInput: '$handlers.DOMInput',
        value: '$_value',
      },
    },
  ],
})
